import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ToastContainer } from 'react-toastify'
import { createBrowserRouter, RouterProvider } from 'react-router'
import App from './App.tsx'

import './index.css'
import NotFound from './components/not-found.tsx'
import JDTool from './features/JDTool/JDTool.tsx'
import CreateJDPage from './features/JDTool/CreateJDPage.tsx'
import MyJDPage from './features/JDTool/MyJDPage.tsx'
import LoginPage from './features/Auth/LoginPage.tsx'
import SendJDPage from './features/JDTool/SendJDPage.tsx'
import LibraryJDPage from './features/JDTool/LibraryJDPage/LibraryJDPage.tsx'
import JDDetailPage from './features/JDTool/JDDetailPage.tsx'

const router = createBrowserRouter([
  {
    path: '/',
    Component: App,
    children: [
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        index: true,
        element: <JDTool />,
      },
      {
        path: 'create-jd',
        element: <CreateJDPage />,
      },
      {
        path: 'my-jd',
        element: <MyJDPage />,
      },
      {
        path: 'send-jd',
        element: <SendJDPage />,
      },
      {
        path: 'library-jd',
        element: <LibraryJDPage />,
      },
      {
        path: 'jd/:id',
        element: <JDDetailPage />,
      },
    ],
  },
  {
    path: '*',
    Component: NotFound,
  },
])

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <StrictMode>
    <RouterProvider router={router} />
    <ToastContainer />
  </StrictMode>
)
